var windowExists = function () { return typeof window !== 'undefined'; };
export var getTHDCustomer = function () {
    var _a;
    var nullUser = {
        customerType: '',
        isB2BCustomer: false,
        isB2XCustomer: false,
        isB2CCustomer: false,
        isLoggedIn: false,
        localizationStatus: 'default',
        isPersisted: false,
        isKMSI: false,
        role: null,
        segment: null,
        svocID: null,
        userID: null,
        token: null,
        jwt: null,
    };
    return windowExists() ? (_a = window === null || window === void 0 ? void 0 : window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default : nullUser;
};
export var isAdmin = function () { var _a; return ((_a = getTHDCustomer()) === null || _a === void 0 ? void 0 : _a.role) === 'ADMIN'; };
export var isDeviceMobile = function () {
    var _a;
    /* requires "x-device-type: mobile" to test */
    return windowExists() && ((_a = window === null || window === void 0 ? void 0 : window.THD_GLOBAL) === null || _a === void 0 ? void 0 : _a.channel) === 'mobile';
};
export var getHostURL = function (pathname) {
    var _a;
    var hostName = 'www.homedepot.com';
    if (windowExists()) {
        hostName = ((_a = window === null || window === void 0 ? void 0 : window.THD_GLOBAL) === null || _a === void 0 ? void 0 : _a.secureHostName) || hostName;
    }
    return "https://".concat(hostName, "/").concat(pathname);
};
export var getImageURL = function (str) {
    return "https://assets.thdstatic.com/images/v1/loyaltyBenefits/".concat(str);
};
export var getRootImageURL = function (str) {
    return "https://assets.thdstatic.com/images/".concat(str);
};
export var getTiersImageURL = function (str) {
    return getImageURL("ProTiers/".concat(str));
};
export var getPricingImageURL = function (str) {
    return getImageURL("PricingBenefits/".concat(str));
};
export var getProXtraPerksImageURL = function (str) {
    return getImageURL("ProXtraPerks/".concat(str));
};
export var getB2bmyaccountFedURL = function (str) {
    // return getImageURL(`b2b/account/dist/${str}`); // won't work for localhost
    return "https://www.homedepot.com/b2b/account/dist/".concat(str);
};
export var editLiveChatZIndex = function () {
    var _a, _b;
    if (!windowExists())
        return;
    var changeZIndex = function (it) {
        var _a, _b;
        (_b = (_a = it === null || it === void 0 ? void 0 : it.parentElement) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('rh-z-index-floor');
    };
    (_a = document
        .querySelectorAll('img[alt="Live Chat"]')) === null || _a === void 0 ? void 0 : _a.forEach(function (it) { return changeZIndex(it); });
    (_b = document
        .querySelectorAll('img[alt="Feedback Link"]')) === null || _b === void 0 ? void 0 : _b.forEach(function (it) { return changeZIndex(it); });
};
export var PAINT_REWARDS_PROGRAM_NAME = 'PRO XTRA PAINT REWARDS';
export var getPaintMembership = function (rewardsAndOffers) {
    if (rewardsAndOffers) {
        var currentYearMemberships = rewardsAndOffers.currentYearMemberships;
        return ((currentYearMemberships === null || currentYearMemberships === void 0 ? void 0 : currentYearMemberships.find(function (membership) {
            return membership.programName === PAINT_REWARDS_PROGRAM_NAME;
        })) || null);
    }
    return null;
};
